import { combineReducers } from 'redux'

import editPage from './editPage'
import imageSources from './imageSources'

export default combineReducers({
  editPage,
  imageSources,
})
